/* bsb-sticky-bar.js */

/* Pre-init stub — bsb-product-info.js may call this before DOMContentLoaded */
let _pendingCart = null;
window.bsbOnCartChange = (cart) => { _pendingCart = cart; };

(() => {
  'use strict';

  function init() {
    const bar      = document.getElementById('bsb-sticky-bar');
    const atcBtn   = document.querySelector('#bsb-sticky-bar .bsb-stk__atc');
    const mainAtc  = document.getElementById('bsb-add-btn') || document.getElementById('bsb-bundle-atc');
    const statusEl = document.getElementById('bsb-stk-status');

    if (!bar) return;

    if (!document.getElementById('bsb-add-to-bundle')) {
      const stkBundleBtn = bar.querySelector('.bsb-stk__bundle');
      if (stkBundleBtn) stkBundleBtn.remove();
    }

    const controller = new AbortController();
    const sig        = { signal: controller.signal };

    /* ── Panel state ──────────────────────────────────────────────── */

    let _open = null;
    let _panelScrollUnlisten = null;

    function openPanel(id) {
      const panel = document.getElementById(`bsb-stk-panel-${id}`);
      const btn   = document.getElementById(`bsb-stk-btn-${id}`);
      if (!panel) return;

      if (_open && _open !== id) closePanel(_open);

      buildOptions(id);

      /* Read geometry before any DOM writes to avoid a double reflow */
      const barRect = bar.getBoundingClientRect();
      const btnRect = btn ? btn.getBoundingClientRect() : null;

      panel.hidden = false;
      if (btn) btn.setAttribute('aria-expanded', 'true');
      _open = id;

      if (_panelScrollUnlisten) {
        window.removeEventListener('scroll', _panelScrollUnlisten);
      }
      const scrollYAtOpen = window.scrollY;
      _panelScrollUnlisten = () => {
        if (window.scrollY < scrollYAtOpen - 120) {
          closePanel(id);
          window.removeEventListener('scroll', _panelScrollUnlisten);
          _panelScrollUnlisten = null;
        }
      };
      window.addEventListener('scroll', _panelScrollUnlisten, { passive: true });

      /* Center panel over its pill button — reads after show so offsetWidth is valid */
      if (btnRect) {
        panel.style.maxWidth = `${barRect.width - 16}px`;
        const panelW    = panel.offsetWidth;
        const btnCenter = btnRect.left + btnRect.width / 2 - barRect.left;
        const left      = Math.max(8, Math.min(btnCenter - panelW / 2, barRect.width - panelW - 8));
        panel.style.left = `${left}px`;
      }
    }

    function closePanel(id) {
      const panel = document.getElementById(`bsb-stk-panel-${id || _open}`);
      const btn   = document.getElementById(`bsb-stk-btn-${id || _open}`);
      if (panel) panel.hidden = true;
      if (btn)   btn.setAttribute('aria-expanded', 'false');
      if (!id || id === _open) _open = null;
      if (_panelScrollUnlisten) {
        window.removeEventListener('scroll', _panelScrollUnlisten);
        _panelScrollUnlisten = null;
      }
    }

    function togglePanel(id) {
      _open === id ? closePanel(id) : openPanel(id);
    }

    /* Close on outside click */
    document.addEventListener('click', (e) => {
      if (_open && !e.target.closest('#bsb-sticky-bar')) closePanel();
    }, sig);

    /* ── Build option lists (lazy, from main form inputs) ─────────── */

    function inputSelectorFor(id) {
      if (id === 'pump') return 'input[name="bsb-pump"], input[name="bsb-pump-option"]';
      return `input[name="bsb-${id}"]`;
    }

    function isSourceSoldOut(source) {
      return !!(source.id && document.querySelector('label[for="' + CSS.escape(source.id) + '"].bsb-pi__sold-out'));
    }

    function applySoldOut(radio, label, source) {
      const soldOut = isSourceSoldOut(source);
      radio.disabled = source.disabled || soldOut;
      label.classList.toggle('bsb-stk__opt--sold-out', soldOut);
      const baseName = label.dataset.baseName;
      if (baseName != null) {
        label.setAttribute('aria-label', soldOut ? baseName + ', sold out' : baseName);
        return;
      }
      let note = label.querySelector('.bsb-stk__sold-out-note');
      if (soldOut && !note) {
        note = document.createElement('span');
        note.className = 'bsb-stk__sold-out-note bsb-visually-hidden';
        note.textContent = ', sold out';
        label.appendChild(note);
      } else if (!soldOut && note) {
        note.remove();
      }
    }

    function buildOptions(id) {
      const container = document.getElementById(`bsb-stk-options-${id}`);
      if (!container) return;

      /* Re-sync checked and sold-out state if already built */
      if (container.children.length) {
        document.querySelectorAll(inputSelectorFor(id)).forEach((source) => {
          const radio = container.querySelector(`input[data-source-id="${source.id}"]`);
          if (!radio) return;
          radio.checked = source.checked;
          const label = container.querySelector(`label[for="${radio.id}"]`);
          if (label) applySoldOut(radio, label, source);
        });
        return;
      }

      const inputs = document.querySelectorAll(inputSelectorFor(id));

      const fieldset = document.createElement('fieldset');
      fieldset.className = 'bsb-stk__fieldset';

      const legend = document.createElement('legend');
      legend.className = 'bsb-stk__fieldset-legend';
      const knownLegends = {
        color: 'Select Color',
        country: 'Select Country',
        planet: 'Select Planet',
        print: 'Select Print',
        letter: 'Select Letter',
        'line-color': 'Select Line Color',
        pump: 'Select Pump',
      };
      if (knownLegends[id]) {
        legend.textContent = knownLegends[id];
      } else if (id.indexOf('opt-') === 0) {
        const pillBtn = document.getElementById(`bsb-stk-btn-${id}`);
        const label = pillBtn && pillBtn.getAttribute('data-option-label');
        legend.textContent = label ? `Select ${label}` : 'Select Option';
      } else {
        legend.textContent = 'Select Size';
      }
      fieldset.appendChild(legend);

      const grid = document.createElement('div');
      grid.className = (id === 'color' || id === 'country' || id === 'planet' || id === 'print') ? 'bsb-stk__color-grid' : 'bsb-stk__size-list';

      inputs.forEach((source) => {
        const optionName = source.getAttribute('data-color-name') || source.getAttribute('data-country-name') || source.value;
        const uid = `bsb-stk-${id}-${source.id}`;

        const radio = document.createElement('input');
        radio.type      = 'radio';
        radio.name      = `bsb-stk-${id}`;
        radio.id        = uid;
        radio.value     = source.value;
        radio.checked   = source.checked;
        radio.disabled  = source.disabled;
        radio.className = 'bsb-stk__opt-radio';
        radio.setAttribute('data-source-id', source.id);

        const label = document.createElement('label');
        label.htmlFor   = uid;
        label.className = (id === 'color' || id === 'country' || id === 'planet' || id === 'print') ? 'bsb-stk__color-opt' : 'bsb-stk__size-opt';

        if (id === 'color') {
          label.setAttribute('aria-label', optionName);
          const inner = document.createElement('span');
          inner.className = 'bsb-stk__color-opt-inner';
          inner.setAttribute('style', source.getAttribute('data-swatch') || '');
          label.appendChild(inner);
        } else if (id === 'country') {
          label.setAttribute('aria-label', optionName);
          const img = document.createElement('img');
          img.className = 'bsb-stk__color-opt-inner bsb-stk__flag-opt-img';
          img.alt       = optionName;
          img.width     = 34;
          img.height    = 34;
          const src80  = source.getAttribute('data-flag-image-80');
          const src160 = source.getAttribute('data-flag-image-160');
          const defaultFlag = document.getElementById('bsb-countries')
            ? document.getElementById('bsb-countries').getAttribute('data-default-flag') || ''
            : '';
          img.src    = src80 || src160 || defaultFlag;
          img.srcset = (src80 ? src80 + ' 80w' : '') + (src80 && src160 ? ', ' : '') + (src160 ? src160 + ' 160w' : '');
          label.appendChild(img);
        } else if (id === 'planet') {
          label.setAttribute('aria-label', optionName);
          const src80  = source.getAttribute('data-planet-image-80');
          const src160 = source.getAttribute('data-planet-image-160');
          if (src80 || src160) {
            const img = document.createElement('img');
            img.className = 'bsb-stk__color-opt-inner bsb-stk__flag-opt-img';
            img.alt       = optionName;
            img.width     = 34;
            img.height    = 34;
            img.src    = src80 || src160;
            img.srcset = (src80 ? src80 + ' 80w' : '') + (src80 && src160 ? ', ' : '') + (src160 ? src160 + ' 160w' : '');
            label.appendChild(img);
          } else {
            /* No swatch image for this planet — the 34px circle is too
               small for a full name, so fall back to a monogram (first
               letter). Still fully functional/selectable; the full name
               remains available to assistive tech via aria-label above. */
            const textSpan = document.createElement('span');
            textSpan.className = 'bsb-stk__color-opt-inner bsb-stk__planet-opt-text';
            textSpan.textContent = optionName.trim().charAt(0).toUpperCase();
            label.appendChild(textSpan);
          }
        } else if (id === 'print') {
          label.setAttribute('aria-label', optionName);
          const src80  = source.getAttribute('data-print-image-80');
          const src160 = source.getAttribute('data-print-image-160');
          if (src80 || src160) {
            const img = document.createElement('img');
            img.className = 'bsb-stk__color-opt-inner bsb-stk__flag-opt-img';
            img.alt       = optionName;
            img.width     = 34;
            img.height    = 34;
            img.src    = src80 || src160;
            img.srcset = (src80 ? src80 + ' 80w' : '') + (src80 && src160 ? ', ' : '') + (src160 ? src160 + ' 160w' : '');
            label.appendChild(img);
          } else {
            const textSpan = document.createElement('span');
            textSpan.className = 'bsb-stk__color-opt-inner bsb-stk__planet-opt-text';
            textSpan.textContent = optionName.trim().charAt(0).toUpperCase();
            label.appendChild(textSpan);
          }
        } else if (id === 'letter' || id === 'line-color' || id === 'pump' || id.indexOf('opt-') === 0) {
          label.textContent = optionName;
        } else {
          label.textContent = formatSize(source.value);
        }

        if (label.hasAttribute('aria-label')) label.dataset.baseName = label.getAttribute('aria-label');
        applySoldOut(radio, label, source);

        grid.appendChild(radio);
        grid.appendChild(label);
      });

      fieldset.appendChild(grid);
      container.appendChild(fieldset);
    }

    function imperialOnly(val) {
      return val
        .split('(')[0]
        .split('/')[0]
        .trim()
        .toLowerCase()
        .replace(/\s*ft\b/, 'ft')
        .replace(/\s*in\b/, '"');
    }

    function formatSize(val) {
      let cm = '';
      let display = val;
      const parenMatch = val.match(/\(([^)]*cm[^)]*)\)/i);
      const slashMatch = val.match(/\/\s*(\d+\.?\d*\s*cm)/i);
      if (parenMatch) {
        cm = parenMatch[1].trim();
        display = val.replace(parenMatch[0], '').trim();
      } else if (slashMatch) {
        cm = slashMatch[1].trim();
        display = val.replace(`/${slashMatch[1]}`, '').replace('/', '').trim();
      }
      display = display.replace(/ FT/i, ' ft').replace(/ IN/i, ' in').trim();
      return cm ? `${display} / ${cm}` : display;
    }

    /* Delegated handler for option buttons (built dynamically) */
    bar.addEventListener('click', (e) => {

      /* Build qty stepper */
      const qtyBtn = e.target.closest('.bsb-stk__build-qty-btn');
      if (qtyBtn) {
        const variantId = parseInt(qtyBtn.getAttribute('data-variant-id'), 10);
        const delta     = qtyBtn.getAttribute('data-action') === 'inc' ? 1 : -1;
        if (typeof window.bsbChangeQty === 'function') window.bsbChangeQty(variantId, delta);
        return;
      }

      /* Build item remove */
      const removeBtn = e.target.closest('.bsb-stk__build-remove');
      if (removeBtn) {
        const variantId = parseInt(removeBtn.getAttribute('data-variant-id'), 10);
        if (typeof window.bsbRemoveFromBundle === 'function') window.bsbRemoveFromBundle(variantId);
        return;
      }

      /* Pill toggle */
      const pillBtn = e.target.closest('.bsb-stk__pill-btn');
      if (pillBtn) {
        const id = pillBtn.id.replace('bsb-stk-btn-', '');
        togglePanel(id);
        return;
      }

      /* Bundle button */
      if (e.target.closest('.bsb-stk__bundle')) {
        if (_open) closePanel();
        if (typeof window.bsbCurrentSoldOut === 'function' && window.bsbCurrentSoldOut()) {
          if (statusEl) {
            statusEl.textContent = 'This option is sold out.';
            setTimeout(() => { statusEl.textContent = ''; }, 4000);
          }
          return;
        }
        if (typeof window.bsbAddToBundle === 'function') {
          window.bsbAddToBundle();
          if (!bundleBtn.dataset.labelHtml) bundleBtn.dataset.labelHtml = bundleBtn.innerHTML;
          bundleBtn.textContent = '✓ Added';
          bundleBtn.classList.add('is-added');
          clearTimeout(bundleBtn._resetTimer);
          bundleBtn._resetTimer = setTimeout(() => {
            bundleBtn.innerHTML = bundleBtn.dataset.labelHtml;
            if (!_buildOpen) bundleBtn.classList.remove('is-added');
          }, 1500);
          setBuildOpen(true, bundleBtn);
        }
        return;
      }

      /* ATC button */
      if (e.target.closest('.bsb-stk__atc')) {
        if (typeof window.bsbIsSoldOut === 'function' && window.bsbIsSoldOut()) {
          if (statusEl) {
            statusEl.textContent = 'This option is sold out.';
            setTimeout(() => { statusEl.textContent = ''; }, 4000);
          }
          return;
        }
        const currentId = typeof window.bsbGetCurrentVariantId === 'function' ? window.bsbGetCurrentVariantId() : null;
        const alreadyInBundle = currentId && _currentCart.some((i) => i.variantId === currentId);
        if (!alreadyInBundle && typeof window.bsbAddToBundle === 'function') window.bsbAddToBundle();
        if (typeof window.bsbSubmitCart === 'function') {
          const btn = atcBtn || e.target.closest('.bsb-stk__atc');
          const saved = btn.innerHTML;
          btn.textContent = 'Adding…';
          btn.disabled = true;
          window.bsbSubmitCart((success) => {
            btn.disabled = false;
            btn.innerHTML = saved;
            if (statusEl) {
              statusEl.textContent = success ? 'Added to cart.' : 'Could not add to cart. Please try again.';
              setTimeout(() => { statusEl.textContent = ''; }, 4000);
            }
          });
        }
        return;
      }

    });

    /* ── Sync pill labels from checked inputs ─────────────────────── */

    /* Updates the visible text of a pill label without clobbering the
       visually-hidden prefix span that precedes it in the DOM. */
    function setPillLabelText(el, text) {
      const last = el.lastChild;
      if (last && last.nodeType === Node.TEXT_NODE) {
        last.textContent = text;
      } else {
        el.appendChild(document.createTextNode(text));
      }
    }

    function syncSoldOut() {
      const stkBundle = bar.querySelector('.bsb-stk__bundle');
      if (stkBundle && typeof window.bsbCurrentSoldOut === 'function') {
        const optionSoldOut = window.bsbCurrentSoldOut();
        stkBundle.classList.toggle('bsb-stk__bundle--sold-out', optionSoldOut);
        stkBundle.setAttribute('aria-disabled', String(optionSoldOut));
      }
      if (!atcBtn || typeof window.bsbIsSoldOut !== 'function') return;
      const soldOut = window.bsbIsSoldOut();
      const wasSoldOut = atcBtn.classList.contains('bsb-stk__atc--sold-out');
      if (soldOut === wasSoldOut) return;
      if (soldOut) {
        atcBtn.dataset.labelHtml = atcBtn.innerHTML;
        atcBtn.textContent = 'Sold out';
      } else if (atcBtn.dataset.labelHtml) {
        atcBtn.innerHTML = atcBtn.dataset.labelHtml;
      }
      atcBtn.classList.toggle('bsb-stk__atc--sold-out', soldOut);
      atcBtn.setAttribute('aria-disabled', String(soldOut));
    }

    const summaryEl = document.getElementById('bsb-stk-summary');

    function syncSummary() {
      if (!summaryEl) return;
      const parts = [];
      const sizeInput = document.querySelector('input[name="bsb-size"]:checked');
      if (sizeInput) parts.push(imperialOnly(sizeInput.value));
      const mainInput = document.querySelector('input[name="bsb-color"]:checked')
        || document.querySelector('input[name="bsb-sport"]:checked')
        || document.querySelector('input[name="bsb-country"]:checked')
        || document.querySelector('input[name="bsb-planet"]:checked')
        || document.querySelector('input[name="bsb-print"]:checked');
      if (mainInput) {
        parts.push(mainInput.getAttribute('data-color-name') || mainInput.getAttribute('data-country-name') || mainInput.value);
      }
      const variant = typeof window.bsbGetCurrentVariant === 'function' ? window.bsbGetCurrentVariant() : null;
      if (variant) parts.push(window.bsbPrice ? window.bsbPrice.format(variant.price) : formatPrice(variant.price));
      summaryEl.textContent = parts.join(' · ');
    }

    function sync() {
      syncSoldOut();
      syncSummary();
      const colorInput   = document.querySelector('input[name="bsb-color"]:checked');
      const countryInput = document.querySelector('input[name="bsb-country"]:checked');
      const planetInput  = document.querySelector('input[name="bsb-planet"]:checked');
      const printInput   = document.querySelector('input[name="bsb-print"]:checked');
      const letterInput  = document.querySelector('input[name="bsb-letter"]:checked');
      const lineColorInput = document.querySelector('input[name="bsb-line-color"]:checked');
      const pumpInput    = document.querySelector('input[name="bsb-pump"]:checked, input[name="bsb-pump-option"]:checked');
      const sizeInput    = document.querySelector('input[name="bsb-size"]:checked');

      if (colorInput) {
        const lbl = document.getElementById('bsb-stk-label-color');
        if (lbl) setPillLabelText(lbl, colorInput.getAttribute('data-color-name') || colorInput.value);
        const swatch = document.getElementById('bsb-stk-swatch');
        if (swatch) swatch.setAttribute('style', colorInput.getAttribute('data-swatch') || '');
        if (swatch) swatch.classList.toggle('bsb-stk__swatch--sold-out', isSourceSoldOut(colorInput));
      }

      if (countryInput) {
        const lbl = document.getElementById('bsb-stk-label-country');
        if (lbl) setPillLabelText(lbl, countryInput.getAttribute('data-country-name') || countryInput.value);
        const flagEl = document.getElementById('bsb-stk-flag');
        if (flagEl) {
          const src = countryInput.getAttribute('data-flag-image-80') || countryInput.getAttribute('data-flag-image-160') || '';
          flagEl.style.backgroundImage = src ? `url('${src}')` : '';
        }
      }

      if (planetInput) {
        const lbl = document.getElementById('bsb-stk-label-planet');
        if (lbl) setPillLabelText(lbl, planetInput.value);
        const iconEl = document.getElementById('bsb-stk-planet-icon');
        if (iconEl) {
          const src = planetInput.getAttribute('data-planet-image-80') || planetInput.getAttribute('data-planet-image-160') || '';
          iconEl.style.backgroundImage = src ? `url('${src}')` : '';
        }
      }

      if (printInput) {
        const lbl = document.getElementById('bsb-stk-label-print');
        if (lbl) setPillLabelText(lbl, printInput.value);
        const iconEl = document.getElementById('bsb-stk-print-icon');
        if (iconEl) {
          const src = printInput.getAttribute('data-print-image-80') || printInput.getAttribute('data-print-image-160') || '';
          iconEl.style.backgroundImage = src ? `url('${src}')` : '';
        }
      }

      if (letterInput) {
        const lbl = document.getElementById('bsb-stk-label-letter');
        if (lbl) setPillLabelText(lbl, letterInput.value);
      }

      if (lineColorInput) {
        const lbl = document.getElementById('bsb-stk-label-line-color');
        if (lbl) setPillLabelText(lbl, lineColorInput.value);
      }

      if (pumpInput) {
        const lbl = document.getElementById('bsb-stk-label-pump');
        if (lbl) setPillLabelText(lbl, pumpInput.value);
      }

      document.querySelectorAll('input[name^="bsb-opt-"]:checked').forEach((extraInput) => {
        const lbl = document.getElementById(`bsb-stk-label-${extraInput.name.replace('bsb-', '')}`);
        if (lbl) setPillLabelText(lbl, extraInput.value);
      });

      if (sizeInput) {
        const szLbl = document.getElementById('bsb-stk-label-size');
        if (szLbl) setPillLabelText(szLbl, imperialOnly(sizeInput.value));
      }
    }

    document.addEventListener('change', (e) => {
      if (e.target.name === 'bsb-color' || e.target.name === 'bsb-size' || e.target.name === 'bsb-sport' || e.target.name === 'bsb-country' || e.target.name === 'bsb-planet' || e.target.name === 'bsb-print' || e.target.name === 'bsb-letter' || e.target.name === 'bsb-line-color' || e.target.name === 'bsb-pump' || e.target.name === 'bsb-pump-option' || e.target.name.indexOf('bsb-opt-') === 0) {
        sync();
        return;
      }
      if (e.target.name === 'bsb-stk-color' || e.target.name === 'bsb-stk-size' || e.target.name === 'bsb-stk-country' || e.target.name === 'bsb-stk-planet' || e.target.name === 'bsb-stk-print' || e.target.name === 'bsb-stk-letter' || e.target.name === 'bsb-stk-line-color' || e.target.name === 'bsb-stk-pump' || e.target.name.indexOf('bsb-stk-opt-') === 0) {
        const sourceId = e.target.getAttribute('data-source-id');
        const source   = sourceId && document.getElementById(sourceId);
        if (source) {
          source.checked = true;
          source.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closePanel();
      }
    }, sig);

    /* ── Build panel ─────────────────────────────────────────────── */

    const buildPanel    = document.getElementById('bsb-stk-build');
    const buildItems    = document.getElementById('bsb-stk-build-items');
    const buildTitle    = document.querySelector('.bsb-stk__build-title');
    const buildHandle   = document.getElementById('bsb-stk-handle');
    const handleCount   = document.getElementById('bsb-stk-handle-count');
    const bundleBtn     = bar.querySelector('.bsb-stk__bundle');
    let _buildOpener = null;
    let _buildOpen   = false;
    let _currentCart = [];

    const FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    if (buildHandle) {
      buildHandle.addEventListener('click', () => setBuildOpen(!_buildOpen, buildHandle), sig);
    }

    const SCROLL_THRESHOLD = 120;
    let _scrollY = 0;
    let _scrollUnlisten = null;

    function setBuildOpen(open, opener) {
      if (open === _buildOpen) return;
      _buildOpen = open;
      buildPanel.classList.toggle('is-open', open);
      if (buildHandle) {
        buildHandle.setAttribute('aria-expanded', open ? 'true' : 'false');
        buildHandle.setAttribute('aria-label', open ? 'Close build summary' : 'Open build summary');
      }
      if (open) {
        buildPanel.removeAttribute('inert');
        /* Only restore focus to an explicit opener (handle click); auto-opens from
           renderBuild leave _buildOpener null so close doesn't refocus/scroll to an
           unrelated, possibly off-screen element (e.g. a swatch far up the page). */
        _buildOpener = opener || null;
        if (bundleBtn) bundleBtn.classList.add('is-added');
        _scrollY = window.scrollY;
        _scrollUnlisten = () => {
          if (window.scrollY < _scrollY - SCROLL_THRESHOLD) setBuildOpen(false);
        };
        window.addEventListener('scroll', _scrollUnlisten, { passive: true });
      } else {
        buildPanel.setAttribute('inert', '');
        if (_buildOpener && typeof _buildOpener.focus === 'function') _buildOpener.focus();
        _buildOpener = null;
        if (bundleBtn) bundleBtn.classList.remove('is-added');
        if (_scrollUnlisten) {
          window.removeEventListener('scroll', _scrollUnlisten);
          _scrollUnlisten = null;
        }
      }
    }

    if (buildPanel) buildPanel.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); setBuildOpen(false); return; }
      if (e.key !== 'Tab') return;
      const focusable = Array.from(buildPanel.querySelectorAll(FOCUSABLE)).filter(
        (el) => !el.closest('[inert]') && !el.disabled
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }, sig);

    function makeBuildRow(item) {
      const isPump      = item.color === '__pump__';
      const thumbStyle  = !isPump && item.swatch ? escapeHtml(item.swatch) : '';
      const name        = isPump ? 'BSB Pump' : `${escapeHtml(item.color)} · ${escapeHtml(item.size)}`;
      const vid         = item.variantId;
      const row         = document.createElement('div');
      row.className     = 'bsb-stk__build-item';
      row.addEventListener('animationend', () => row.classList.remove('is-new'));
      row.setAttribute('data-variant-id', vid);
      row.innerHTML = (
        `<div class="bsb-stk__build-thumb" style="${thumbStyle}" aria-hidden="true"></div>` +
        `<div class="bsb-stk__build-body">` +
          `<div class="bsb-stk__build-head">` +
            `<div class="bsb-stk__build-info">` +
              `<div class="bsb-stk__build-name">${name}</div>` +
              `<div class="bsb-stk__build-unit">${formatPrice(item.price)} each</div>` +
            `</div>` +
            `<div class="bsb-price bsb-stk__build-price"></div>` +
          `</div>` +
          `<div class="bsb-stk__build-actions">` +
            `<div class="bsb-qty bsb-stk__build-qty" role="group" aria-label="Quantity of ${name}">` +
              `<button class="bsb-qty__btn bsb-stk__build-qty-btn" type="button" data-action="dec" data-variant-id="${vid}" aria-label="Decrease quantity of ${name}">&minus;</button>` +
              `<span class="bsb-qty__value bsb-stk__build-qty-val">${item.qty}</span>` +
              `<button class="bsb-qty__btn bsb-stk__build-qty-btn" type="button" data-action="inc" data-variant-id="${vid}" aria-label="Increase quantity of ${name}">+</button>` +
            `</div>` +
            `<button class="bsb-stk__build-remove" type="button" data-variant-id="${vid}">Remove<span class="bsb-visually-hidden"> ${name}</span></button>` +
          `</div>` +
        `</div>`
      );
      renderLinePrice(row.querySelector('.bsb-stk__build-price'), item);
      return row;
    }

    function renderLinePrice(el, item) {
      if (!el) return;
      const line = item.price * item.qty;
      const compare = item.compareAtPrice > item.price ? item.compareAtPrice * item.qty : 0;
      if (window.bsbPrice) {
        window.bsbPrice.render(el, line, compare);
      } else {
        el.textContent = formatPrice(line);
      }
    }

    function flashRow(row) {
      row.classList.remove('is-new');
      void row.offsetWidth;
      row.classList.add('is-new');
    }

    function renderBuild(cart, flash = true) {
      _currentCart = cart || [];
      if (!buildItems) return;

      if (!cart || !cart.length) {
        setBuildOpen(false);
        if (buildHandle) buildHandle.hidden = true;
        if (atcBtn) { atcBtn.disabled = true; }
        return;
      }

      const totalQty   = cart.reduce((s, i) => s + i.qty, 0);
      const totalPrice = cart.reduce((s, i) => s + i.price * i.qty, 0);

      if (atcBtn) atcBtn.disabled = false;

      const wasHidden = buildHandle ? buildHandle.hidden : true;

      if (buildHandle) {
        buildHandle.hidden = false;
        buildHandle.setAttribute('aria-label', `View bundle · ${totalQty} ${totalQty === 1 ? 'item' : 'items'}`);
        if (handleCount) handleCount.textContent = `${totalQty} ${totalQty === 1 ? 'item' : 'items'}`;
      }

      /* Auto-open only on the first item added so user sees the drawer */
      if (wasHidden) setBuildOpen(true);

      if (buildTitle) buildTitle.textContent = `Your bundle (${totalQty})`;

      /* Index existing rows by variantId */
      const existingRows = {};
      buildItems.querySelectorAll('.bsb-stk__build-item[data-variant-id]').forEach((el) => {
        existingRows[el.getAttribute('data-variant-id')] = el;
      });

      /* Add or patch rows */
      const seen = {};
      cart.forEach((item) => {
        const key      = String(item.variantId);
        seen[key]      = true;
        const existing = existingRows[key];
        if (existing) {
          const qtyEl   = existing.querySelector('.bsb-stk__build-qty-val');
          const priceEl = existing.querySelector('.bsb-stk__build-price');
          if (flash && qtyEl && item.qty > parseInt(qtyEl.textContent, 10)) flashRow(existing);
          if (qtyEl)   qtyEl.textContent   = item.qty;
          renderLinePrice(priceEl, item);
        } else {
          const totals = buildItems.querySelector('.bsb-stk__build-totals');
          const row = makeBuildRow(item);
          buildItems.insertBefore(row, totals || null);
          if (flash) flashRow(row);
        }
      });

      /* Remove rows no longer in cart */
      Object.keys(existingRows).forEach((key) => {
        if (!seen[key]) existingRows[key].remove();
      });

      /* Patch or create totals block (discount + total) */
      const pct      = typeof window.bsbDiscountPct === 'function' ? window.bsbDiscountPct() : 0;
      const disc     = Math.round(totalPrice * pct);
      const finalAmt = totalPrice - disc;
      const wasTotal = cart.reduce((s, i) => s + Math.max(i.compareAtPrice || 0, i.price) * i.qty, 0);

      let totalsBlock = buildItems.querySelector('.bsb-stk__build-totals');
      if (!totalsBlock) {
        totalsBlock = document.createElement('div');
        totalsBlock.className = 'bsb-stk__build-totals';
        buildItems.appendChild(totalsBlock);
      }

      totalsBlock.innerHTML =
        (disc > 0
          ? `<div class="bsb-bc__totals-row">` +
              `<span class="bsb-bc__totals-label">Bundle discount (${Math.round(pct * 100)}% off)</span>` +
              `<span class="bsb-bc__totals-value bsb-bc__totals-value--discount">−${formatPrice(disc)}</span>` +
            `</div>`
          : '') +
        `<div class="bsb-bc__totals-row bsb-bc__totals-row--total">` +
          `<span class="bsb-bc__totals-label">Total</span>` +
          `<span class="bsb-price bsb-bc__totals-value bsb-bc__totals-value--total">${formatPrice(finalAmt)}</span>` +
        `</div>`;
      if (window.bsbPrice) {
        window.bsbPrice.render(totalsBlock.querySelector('.bsb-bc__totals-value--total'), finalAmt, wasTotal);
      }
    }

    function escapeHtml(s) {
      if (!s) return '';
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatPrice(cents) {
      const amount = cents / 100;
      return '$' + amount.toLocaleString(undefined, {
        minimumFractionDigits: amount % 1 !== 0 ? 2 : 0,
        maximumFractionDigits: 2,
      });
    }

    /* Replace stub with real handler, drain any call that arrived before init */
    window.bsbOnCartChange = renderBuild;
    if (_pendingCart !== null) { renderBuild(_pendingCart, false); _pendingCart = null; }

    /* ── Show/hide via IntersectionObserver (zero per-scroll layout reads) ── */

    let _visible = false;

    function barFootprint() {
      const card = bar.querySelector('.bsb-stk__bar, .bsb-stk__min');
      return card ? bar.offsetHeight - card.offsetTop : bar.offsetHeight;
    }

    function setBarVisible(show) {
      if (show === _visible) return;
      _visible = show;
      bar.classList.toggle('is-visible', show);
      if (show) {
        bar.removeAttribute('inert');
      } else {
        bar.setAttribute('inert', '');
      }
      document.documentElement.style.setProperty('--bsb-stk-height', show ? `${(barFootprint() || 64) + 8}px` : '0px');
    }

    if (mainAtc && typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        // Only show when element has scrolled above viewport top, not when pushed below fold
        setBarVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      observer.observe(mainAtc);
    } else if (mainAtc) {
      const checkVisibility = () => {
        const rect = mainAtc.getBoundingClientRect();
        setBarVisible(rect.bottom < 0);
      };
      window.addEventListener('scroll', checkVisibility, { passive: true, signal: controller.signal });
      window.addEventListener('resize', checkVisibility, { passive: true, signal: controller.signal });
      checkVisibility();
    }

    /* ── Init ─────────────────────────────────────────────────────── */

    sync();
    if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', sync, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();